import React from 'react';
import { FieldError, useFormContext } from 'react-hook-form';

interface InputPresentationalTaxCodeProps {
  disabled?: boolean;
  readOnly?: boolean;
  info?: string;
  defaultValue?: string | number;
  required?: boolean;
  legendIcons?: JSX.Element[];
  error?: FieldError;
  label?: string;
  regex?: string | null;
  validationErrorMessage?: string | null;
}
const InputPresentationalTaxCode: React.FC<InputPresentationalTaxCodeProps> = ({
  disabled,
  readOnly,
  info,
  defaultValue,
  required,
  legendIcons,
  error,
  label = 'Codice fiscale (o numero identificativo usato nel tuo stato)',
  regex,
  validationErrorMessage,
}) => {
  const { register } = useFormContext();

  return (
    <div className='w-full'>
      <div className='flex'>
        <label
          htmlFor='fiscalCode'
          className='flex justify-between text-sm text-gray-500'
        >
          <div>{`${label}${required ? ' *' : ''}`} </div>
        </label>
        {legendIcons && (
          <ul className='flex flex-row'>
            {legendIcons.map((legendIcon, idx) => {
              return (
                <li className='flex h-5 mx-1' key={`input-legend-${idx}`}>
                  {legendIcon}
                </li>
              );
            })}
          </ul>
        )}
      </div>

      <div className='mt-1 flex items-center'>
        <input
          id='fiscalCode'
          type='text'
          autoComplete='fiscalCode'
          {...(register &&
            register('fiscalCode', {
              required,
            }))}
          defaultValue={defaultValue}
          disabled={disabled}
          readOnly={readOnly}
          aria-describedby={info ? 'fiscalCode-info' : undefined}
          pattern={regex || undefined}
          title={
            regex
              ? validationErrorMessage ||
                'Inserire un codice identificativo valido'
              : undefined
          }
          className={`appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:ring-0 focus:border-gray-500 text-gray-800 read-only:bg-slate-50 read-only:text-slate-500 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none ${
            error?.message
              ? 'border-red-100 focus:border-red-100 border-[1px]'
              : ''
          }`}
        />
      </div>
      {info && (
        <p id='fiscalCode-info' className='mt-2 text-sm text-gray-500'>{info}</p>
      )}
      {error && error.message && (
        <p className='mt-2 text-sm text-red-500'>{error.message}</p>
      )}
    </div>
  );
};
export default InputPresentationalTaxCode;
